import SideBar from './SideBar.component';

export default SideBar;
